import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [
    'filterLink',
  ]

  get galleryGridContainers() {
    return document.querySelectorAll('.js-gallery-grid-container');
  }

  get imageGridContainer() {
    return document.querySelector('[data-asset-type="image"]');
  }

  get videoGridContainer() {
    return document.querySelector('[data-asset-type="video"]');
  }

  connect() {
    this.clearFilter();
    this.filterLinkTargets.forEach((el) => {
      el.addEventListener('click', this.filterAssets.bind(this));
      el.addEventListener('keydown', this.handleKeydown.bind(this));
      el.addEventListener('focus', this.handleFocus.bind(this));
    })
  }

  handleKeydown(event) {
    const { key } = event;
    const tabs = this.filterLinkTargets;
    const currentIndex = tabs.indexOf(event.target);
    let newIndex = currentIndex;

    if (key === 'ArrowRight') {
      newIndex = (currentIndex + 1) % tabs.length;
    } else if (key === 'ArrowLeft') {
      newIndex = (currentIndex - 1 + tabs.length) % tabs.length;
    } else {
      return;
    }

    event.preventDefault();
    const newTab = tabs[newIndex];

    newTab.focus();
  }

  handleFocus(event) {
    this.filterAssets(event);
  }

  filterAssets(event) {
    event.preventDefault();
    const clickedTab = event.currentTarget;
    const assetFilter = clickedTab.dataset.assetFilter;

    this.setActiveTab(clickedTab);
    this.activateTabpanel(assetFilter);

    Site.lazyLoadAssets();
  }

  setActiveTab(tab) {
    this.filterLinkTargets.forEach((el) => {
      el.classList.remove('is-active');
      el.setAttribute('aria-selected', 'false');
      el.setAttribute('tabindex', '-1');
    })

    tab.classList.add('is-active');
    tab.setAttribute('aria-selected', 'true');
    tab.removeAttribute('tabindex');
  }

  activateTabpanel(assetFilter) {
    this.galleryGridContainers.forEach((el) => {
      if (el.dataset.assetType !== assetFilter) {
        el.classList.add('-is-hidden');
      } else {
        el.classList.remove('-is-hidden');
      }
    });
  }

  clearFilter() {
    this.imageGridContainer.classList.remove('-is-hidden');
    this.videoGridContainer.classList.add('-is-hidden');
  }
}

